import * as React from "react";

interface SeparatorProps {
  text?: string;
}

import styles from "./index.module.css";

function Separator(props: SeparatorProps) {
  return <div className={styles.separator}>{props.text}</div>;
}

export default Separator;
